import state from './moduleDataAccessState'
import mutations from './moduleDataAccessMutations'
import actions from './moduleDataAccessActions'
import getters from './moduleDataAccessGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
